import { useRoutes } from "react-router-dom"
import { Suspense, lazy } from "react"
import { PageLoader } from "src/shared/components"
import appRoutes from "./app-routes"
import InvoicePreview from "src/modules/invoice/pages/invoice-preview"

// React 19: Enhanced lazy loading with better error boundaries
const Login = lazy(() => import("src/modules/auth/pages/Login"))
const ResetPassword = lazy(() => import("src/modules/auth/pages/reset-password"))
const ForgotPassword = lazy(() => import("src/modules/auth/pages/forgot-password"))
const Navigateto404 = lazy(() => import("src/modules/error/pages/Navigateto404"))
const NotFound404 = lazy(() => import("src/modules/error/pages/NotFound404"))

// React 19: Optimized wrapper component for lazy loading
const LazyLoad = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<PageLoader isLoading={true} />}>{children}</Suspense>
)

const Routes = () => {
  const PublicRoutes = [
    {
      path: "/",
      element: (
        <LazyLoad>
          <Login />
        </LazyLoad>
      )
    },
    {
      path: "404",
      element: (
        <LazyLoad>
          <NotFound404 />
        </LazyLoad>
      )
    },
    {
      path: "/password-reset/new",
      element: (
        <LazyLoad>
          <ForgotPassword />
        </LazyLoad>
      )
    },
    {
      path: "/password-reset/change",
      element: (
        <LazyLoad>
          <ResetPassword />
        </LazyLoad>
      )
    },
    {
      path: "/invoice/preview/:id",
      element: (
        <LazyLoad>
          <InvoicePreview />
        </LazyLoad>
      )
    },
    {
      path: "*",
      element: (
        <LazyLoad>
          <Navigateto404 />
        </LazyLoad>
      )
    },
    appRoutes
  ]

  return useRoutes([...PublicRoutes])
}

export default Routes
